<div class="access-request">
  <header>
    <div class="logo" [routerLink]="['./']">
      <img src="assets/img/accesshublogo.png" alt="accesshublogo">
    </div>
  </header>

  <div class="content">
    <div class="info-block">
      <div class="header">
        <div class="image">
          <img src="assets/img/accesshublogo.png" alt="accesshublogo">
        </div>
        <div class="title">User Access Request</div>
        <div class="subtitle">You already have an active request. Please wait until the request is processed.</div>
      </div>
    </div>
  </div>

  <div class="footer">
    <span class="copyright">Copyright © 2021 AbbVie Inc. North Chicago, Illinois, U.S.A.</span>
    <div>
      <a href="mailto:AccessHub@abbvie.com"><i></i>Questions, Comments or Feedback?</a>
    </div>
  </div>
</div>
